import Button from '@/components/basicComponents/button';
import Header from '@/components/header';
import { GoBackButton } from '@/components/header/goBackButton';
import { PageTitle } from '@/components/header/pageTitle';
import { MainWrap } from '@/styles/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SettingsContainer, SettingsItem, SettingsItemButtonWrapper, SettingsItemTitle, SettingsWrapper } from '..';
import { CatalogBanner } from './catalogBanner';
import { FirmInfo } from './firmInfo';
import { TemplatesSettings } from './templatesSettings';
import { ThemeSettings } from './themeSettings';

const platformSettingsItems = [
  { title: 'Firm Info', path: 'firmInfo' },
  { title: 'Theme', path: 'theme' },
  { title: 'Catalog Banner', path: 'catalogBanner' },
  { title: 'Templates', path: 'templates' }
];

interface PlatformSettingsProps {
  handleClosePlatformSettings: () => void;
  backToTitle?: string;
}

export const PlatformSettings = ({ handleClosePlatformSettings, backToTitle }: PlatformSettingsProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const action = searchParams.get('action') || 'default';
  const type = searchParams.get('type') || 'default';

  const handleRedirect = (path: string) => {
    navigate(`/settings?action=${action}&type=${path}`);
  };

  const handleClose = () => {
    navigate(`/settings?action=${action}`);
  };

  return (
    <>
      {type === 'firmInfo' && <FirmInfo handleClose={handleClose} backToTitle="Platform Settings" />}
      {type === 'theme' && <ThemeSettings handleClose={handleClose} backToTitle="Platform Settings" />}
      {type === 'catalogBanner' && <CatalogBanner handleClose={handleClose} backToTitle="Platform Settings" />}
      {type === 'templates' && <TemplatesSettings handleClose={handleClose} backToTitle="Platform Settings" />}
      {type === 'default' && (
        <MainWrap>
          <Header modalControl={<GoBackButton handleClose={handleClosePlatformSettings} backToTitle={backToTitle} />} />
          <PageTitle title="Platform Settings" />
          <SettingsContainer>
            <SettingsWrapper>
              {platformSettingsItems.map((item) => (
                <SettingsItem key={item.path}>
                  <SettingsItemTitle id="itemTitle" onClick={() => handleRedirect(item.path)}>
                    {item.title}
                  </SettingsItemTitle>
                  <SettingsItemButtonWrapper id="openButton">
                    <Button onClick={() => handleRedirect(item.path)}>Open</Button>
                  </SettingsItemButtonWrapper>
                </SettingsItem>
              ))}
            </SettingsWrapper>
          </SettingsContainer>
        </MainWrap>
      )}
    </>
  );
};
